module.exports = require('./helpers/bundle-url').getBundleURL('3Ntop') + "logo.c51670a8.svg";